const UPLOAD_BASE_ROUTE = '/upload';

export const UPLOAD_API_ROUTES = {
  baseRoute: () => UPLOAD_BASE_ROUTE,
  init: () => `${UPLOAD_BASE_ROUTE}/init`,
  complete: () => `${UPLOAD_BASE_ROUTE}/complete`,
} as const;
